/**
 * DEBUG-log-downstream-message.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { validateAs, validateFor } from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

/**
 * A server may transmit asynchronously a {@link DebugLogDownstreamMessage}.
 * This constitutes a request for the client to present an arbitrary value. This
 * mechanism is intended only for debugging.
 */
@validateFor(MessageTag.DBG_DOWN_LOG)
export class DebugLogDownstreamMessage extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.DBG_DOWN_LOG;

  @validateAs([])
  public content : any;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/debug/DEBUG-log-downstream-message.ts